import Api from '../api'

export default {
    getStatus(applicantInput) {
        return Api.post('/ApplicationStatus/GetStatus', JSON.stringify(applicantInput))
    }
}